import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Form, InputNumber, Modal, Popconfirm, Row, Space } from "antd"
import { useState } from "react"
import { InfoCard } from "../../UnitPanel/components/common/InfoCard"
import { Node } from "@antv/x6"
import { cellToNodeState } from "@/components/FlowSheetEditor/services/storage"
import { BasicNozzle } from "@/components/FlowSheetEditor/services/modal"
import { PortTypes } from "@/components/FlowSheetEditor/constant"
import { v4 as uuidv4 } from "uuid";
import { useGraphInstance } from "@antv/xflow"

interface LineNozzlesProps {
  node: Node
}

export const LineNozzles = (props: LineNozzlesProps) => {
  const {node} = props;
  const nodeState = cellToNodeState(node)
  const graph = useGraphInstance()
  const [value, setValue] = useState<BasicNozzle[]>(nodeState.lineNozzles || [])
  const [showEditor, setShowEditor] = useState(false)
  const [form] = Form.useForm()

  const onSave = (values) => {
    const {x,y} = values
    const newItem: BasicNozzle = {
      layout: {x, y},
      group: PortTypes.LinePort,
      id: uuidv4(),
    }
    node.addPort({
      id: newItem.id,
      group: PortTypes.LinePort,
      data: newItem,
      args: {x, y}
    })
    setValue([...value, newItem])
    onCancel()
  }

  const onCancel = () => {
    form.resetFields()
    setShowEditor(false)
  }

  const onChange = () => {
    const node = graph?.getCellById(nodeState.id) as Node
    if (node) {
      const newState = cellToNodeState(node)
      setValue(newState.lineNozzles || [])
    }
  }
  
  return <InfoCard title={'Line Nozzles'} action={<Button icon={<PlusOutlined />} onClick={() => setShowEditor(true)}/>}>
  <EditableLineNozzlesTable nozzles={value} node={node} onChange={onChange} />
  {showEditor && <div className="mt-1">
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
        <Form.Item
          name='x'
          label='X'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2}  />
        </Form.Item>
        <Form.Item
          name='y'
          label='Y'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2} />
        </Form.Item>

        <Row justify={'end'} className="mt-2">
          <Space>
            <Button htmlType="button" onClick={() => onCancel()}>Cancel</Button>
            <Button type="primary" htmlType="submit">Save</Button>
          </Space>
        </Row>
    </Form>
  </div>}
  </InfoCard>
}

export interface LineNozzlesTableProps {
  nozzles: BasicNozzle[]
  node: Node
  onChange: () => void
  deleteAble?: boolean
}

export const EditableLineNozzlesTable = (props: LineNozzlesTableProps) => {
  const {nozzles, node, onChange, deleteAble = true} = props;
  const [form] = Form.useForm()
  const [edit, setEdit] = useState<BasicNozzle | null>(null)

  const delConfirm = (item) => {
    node.removePort(item.id)
    onChange()
  }

  const onEdit = (item: BasicNozzle) => {
    setEdit(item)
    form.setFieldsValue({
      x: item.layout?.x || 0,
      y: item.layout?.y || 0
    })
  }

  const cancelEdit = () => {
    form.setFieldsValue({})
    setEdit(null)
  }

  const onSave = (values) => {
    const {name, x, y} = values;
    const port = node.getPort(edit!.id)
    if (port) {
      port.data.name = name;
      port.data.layout.x = x;
      port.data.layout.y = y;
      node.setPortProp(edit!.id, 'data', port.data)
      node.setPortProp(edit!.id, 'args', {x, y})
    }
    onChange()
    cancelEdit()
  }

  return <><table className="bordered-table">
    <thead>
      <tr>
        <td>X</td>
        <td>Y</td>
        <td>Action</td>
      </tr>
    </thead>
    <tbody>
      {nozzles.map(item => {
        return <tr key={item.id}>
          <td>{item.layout?.x}</td>
          <td>{item.layout?.y}</td>
          <td>
            <Space>
              {deleteAble && <Popconfirm
                title="Delete nozzle"
                description={`Are you sure to delete the line nozzle?`}
                onConfirm={() => delConfirm(item)}
                okText="Yes"
                cancelText="No"
              >
                <Button icon={<DeleteOutlined />} danger />
              </Popconfirm>}
              <Button icon={<EditOutlined />} onClick={() => onEdit(item)} />
            </Space>
          </td>
        </tr>
      })}
    </tbody>

  </table>
  <Modal
    {...props}
    width={600}
    open={!!edit}
    onCancel={cancelEdit}
    okText="Save"
    onOk={() => form.submit()}
  >
    <div>Edit Nozzle</div>
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
        <Form.Item
          name='x'
          label='X'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2}  />
        </Form.Item>
        <Form.Item
          name='y'
          label='Y'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2} />
        </Form.Item>
      </Form>
    </Modal>
  </>
}